import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { memo } from 'react';
import { useFragmentGridContext } from '../fragments-grid/FragmentGridContext';
import { AudioFragmentCard } from './audio/AudioFragmentCard';
import { VideoFragmentCard } from './video/VideoFragmentCard';

/**
 * Renders a fragment card: audio variant (no media, no social icons) or video variant
 * (poster, overlay, social upload icons). Chooses based on station type from FragmentGridContext.
 */
export const FragmentCard = memo(function FragmentCard({
  fragment,
}: {
  fragment: FragmentListItemDto;
}) {
  const { isVideo } = useFragmentGridContext();

  if (isVideo) {
    return <VideoFragmentCard fragment={fragment} />;
  }

  return <AudioFragmentCard fragment={fragment} />;
});
